import { cn } from "@/lib/cn";

export interface FilterOption<T extends string> {
  value: T;
  label: string;
}

export function SegmentedFilter<T extends string>({
  options,
  value,
  onChange,
  className,
}: {
  options: FilterOption<T>[];
  value: T;
  onChange: (value: T) => void;
  className?: string;
}) {
  return (
    <div className={cn("flex items-center gap-1.5 flex-wrap", className)}>
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          onClick={() => onChange(opt.value)}
          className={cn(
            "h-8 px-3 rounded-pill text-xs font-semibold border transition-all",
            value === opt.value
              ? "bg-primary text-white border-primary"
              : "bg-bg3 text-text2 border-border hover:bg-bg4 hover:text-text hover:border-border2",
          )}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
